module.exports = __webpack_public_path__ + "static/media/user-default.08a2447c.jpg";